import { render } from "./BehalfApplication.vue?vue&type=template&id=39defa9c&scoped=true"
import script from "./BehalfApplication.vue?vue&type=script&lang=js"
export * from "./BehalfApplication.vue?vue&type=script&lang=js"

import "./BehalfApplication.vue?vue&type=style&index=0&id=39defa9c&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-39defa9c"]])

export default __exports__